import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-move",
  "use": "icon-move-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-move\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M16.44,13a.53.53,0,0,1,.56.5.51.51,0,0,1-.46.49h-9A.53.53,0,0,1,7,13.5.51.51,0,0,1,7.46,13h9Zm0-3a.53.53,0,0,1,.56.5.51.51,0,0,1-.46.49h-9A.53.53,0,0,1,7,10.5.51.51,0,0,1,7.46,10h9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol